import * as React from 'react';
import PopoverClose from './PopoverClose';

export interface PopoverTitleProps {
	titleText: string;
	hideTitleText?: boolean;
	renderBack?: () => React.ReactNode;
	close: () => void;
}

/**
 * Reusable component for popover title.
 *
 * @param {PopoverTitleProps} props
 * @returns
 */
function PopoverTitle(props: PopoverTitleProps) {
	const { titleText, close, renderBack, hideTitleText = false } = props;

	return (
		<h2 className="popover-title">
			{renderBack ? renderBack() : <div className="popover-title-back" />}
			<span className={'popover-title-text' + (hideTitleText ? ' visually-hidden' : '')}>{titleText}</span>
			<div className="popover-title-close">
				<PopoverClose toggle={close} />
			</div>
		</h2>
	);
}

export default PopoverTitle;
